<template>
  <div class="container" style="background-color: #eeeeee; padding-bottom: 100px">
    <img style="display: block; margin: 0 auto" src="../../assets/banner3.png" alt="" />
    <div class="main">
      <!-- <Breadcrumb /> -->
      <ul class="Breadcrumb" style="margin-bottom: 0">
        <li @click="backPage('/home')">{{ $t("home") }}</li>
        <li v-for='item in treeData'>
          <span>></span><i class='' @click="goPath(item.id)">{{item.name}}</i>
        </li>
      </ul>
      <div>
        <h3 class="title">{{ $t("NewProductReleases") }}</h3>
        <el-row :gutter="60">
          <el-col
            v-for="(item, index) in newProductList.slice(0, 3)"
            :key="index"
            :span="8"
          >
            <div class="newItem">
              <p class="name">{{ item.name }}</p>
              <p class="description">{{ item.description }}</p>
              <p @click="check(item)" class="checkDetail">{{$t('productDetail')}} <span>></span></p>
            </div>
            <div class="grid-content bg-purple"></div
          ></el-col>
        </el-row>

        <h3 class="title">{{ $t("ProductSelectionTable") }}</h3>
        <div class="table_wrap">
          <div class="table_top">
            <el-form
              :inline="true"
              class="demo-form-inline"
              size="small"
              @submit.native.prevent
            >
              <el-form-item>
                <el-popover
                  placement="bottom-end"
                  offset="100px"
                  v-model="visible"
                  width="260"
                >
                  <el-aside v-show="showCheck" width="238px" class="checkbox">
                    <el-checkbox
                      v-for="(item, index) in typeList"
                      :key="item.id"
                      v-model="item.isChecked"
                      >{{ item.name }}</el-checkbox
                    >
                  </el-aside>
                  <el-checkbox v-model="visible" slot="reference" @change="visible = true"
                    >{{ $t("Filters") }}</el-checkbox
                  >
                </el-popover>
              </el-form-item>

              <el-form-item>
                <el-input
                  @change="searchProduct"
                  v-model="name"
                  suffix-icon="el-icon-search"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  style="font-size: 14px"
                  type="text"
                  @click="reset"
                  icon="el-icon-refresh-right"
                  >{{ $t("Reset") }}</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <el-container>
            <el-main style="padding: 0">
              <el-table
                :data="productList"
                border
                style="width: 100%"
                class="typeTable"
                @sort-change="sortChange"
                :header-cell-style="headerCellStyle"
                center
              >
                <el-table-column prop="name" :label="languageCode=='zh'?'产品型号':'Model'" fixed width="80">
                  <template #default="scope">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="getInfo(scope.row)"
                      placement="top-start"
                    >
                      <a
                        style="
                          cursor: pointer;
                          font-size: 13px;
                          color: #426c9b;
                          text-decoration: underline;
                        "
                        @click="check(scope.row)"
                        target="_blank"
                        >{{ scope.row.name }}</a
                      >
                    </el-tooltip>
                  </template>
                  <!-- <template slot-scope="scope">
                  <p>
                    <a
                      style="cursor: pointer; font-size: 13px;color:#426c9b;text-decoration:underline;"
                      @click="check(scope.row)"
                      target="_blank"
                      >{{ scope.row.name }}</a
                    >
                  </p>
                   
                  </template> -->
                </el-table-column>
                <el-table-column prop="date" label="产品手册" width="80" v-if="languageCode == 'zh'">
                  <template slot-scope="scope">
                    <a
                      style="display: block; margin: 0px auto; width: 24px; height: 24px"
                      v-if="scope.row.sheet != null"
                      :href="scope.row.sheet"
                      target="_blank"
                      ><img src="../../assets/img30.png" alt=""
                    /></a>
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="(item, index) in typeTableList"
                  :width="item.columnWidth"
                  :prop="item.id.toString()"
                  :label="item.name"
                  :key="item.id"
                  :render-header="renderHeader"
                  v-if="item.isChecked"
                  show-overflow-tooltip
                >
                  <el-table-column :width="item.columnWidth" show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                      <el-popover
                        v-if="item.attrType == 2"
                        placement="bottom"
                        width="200"
                        trigger="click"
                      >
                        <div>
                          <el-checkbox-group
                            v-model="checkList"
                            @change="handleCheckedChange"
                          >
                            <el-checkbox :label="'asc' + '#' + item.id">升序</el-checkbox>
                            <el-checkbox :label="'desc' + '#' + item.id"
                              >降序</el-checkbox
                            >
                          </el-checkbox-group>
                          <el-divider></el-divider>
                          <input-number-range
                            @changeto="changeto"
                            v-model="item.interval"
                          ></input-number-range>
                          <el-button
                            type="primary"
                            style="float: right; margin-top: 10px"
                            size="mini"
                            plain
                            @click="changeCon"
                            >确定</el-button
                          >
                        </div>
                        <el-button
                          size="mini"
                          style="font-size: 14px; margin-top: -26px"
                          type="text"
                          slot="reference"
                          icon="el-icon-s-operation"
                        ></el-button>
                      </el-popover>
                      <!-- {{item}} -->
                    </template>
                    <template slot-scope="scope">
                      {{ getTypeName(scope.row.attrRelations, item.id, item.attrType) }}
                      <!-- {{item.id}} -->
                      <!-- {{scope.row.attrRelations}} -->
                    </template>
                  </el-table-column>
                  <template slot="header" slot-scope="scope">
                    <span
                      style="
                        -webkit-line-clamp: 1;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: normal;
                      "
                      v-if="item.attrType == 1"
                      >{{ item.name }}</span
                    >
                    <span
                      v-if="item.attrType == 2"
                      style="
                        -webkit-line-clamp: 1;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: normal;
                      "
                      >{{ item.name }}</span
                    >

                    <!-- {{item}} -->
                  </template>
                  <template slot-scope="scope">
                    {{ getTypeName(scope.row.attrRelations, item.id, item.attrType) }}
                    <!-- {{item.id}} -->
                    <!-- {{scope.row.attrRelations}} -->
                  </template>

                  <!-- </el-table-column> -->
                </el-table-column>
              </el-table>
              <pagination
                v-if="productList.length > 0"
                style="margin-top: 10px"
                :num="total"
                :limit="10"
                @getNew="getList"
              ></pagination>
            </el-main>
          </el-container>
          <p v-if="id==20" @click='goPath1' style="font-size: 14px; text-indent: 20px; margin-top: -28px; color: #e5004f;cursor:pointer" >
          更多高速ADC产品，请咨询销售
          </p>
        </div>

        <!-- <div class="apply none" v-else>暂无数据</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { getProductTree, getProductList, getProductTypeList,getProductDetail } from "../../api/index";
import { findNodePath , getLocalizedPath} from "../../utils/common";
import pagination from "@/components/page/pagination.vue";
import InputNumberRange from "./InputNumberRange";

export default {
  components: {
    pagination,
    InputNumberRange,
  },
  data() {
    return {
      active: null,
      productList: [],
      newProductList: [],
      defaultProps: {
        children: "childrens",
        label: "name",
      },
      id: "",
      total: 0,
      checkedAll: true,
      name: "",
      typeList: [],
      typeTableList: [],
      value: [],
      sortParams: null,
      checkedList: [],
      showCheck: true,
      checkList: [],
      range: [],
      visible: false,
      treeData:[],
      languageCode:'zh'
    };
  },
  watch: {
    $route: {
      handler(n, o) {
        this.drawer = false;
        this.lang = this.$route.params.lang
      },
      deep: true,
    },
    "$i18nState.locale": {
      handler() {
        this.loadMenuData();
      },
      immediate: false,
    },
  },
  methods: {
    getLocalizedPath(rawPath) {
    const currentLang = this.$i18nState.locale || "zh";
    // 如果路径已经以 /zh 或 /en 结尾，则直接返回
    if (/\/(zh|en)$/.test(rawPath)) {
      return rawPath;
    }
    // 移除路径末尾多余的斜杠，然后添加语言
    const base = rawPath.endsWith("/") ? rawPath.slice(0, -1) : rawPath;
    return `${base}/${currentLang}`;
    },
    goPath(id){
      console.log(id);
      const fullPath = this.getLocalizedPath("/product/index");
      this.$router.replace({ path: fullPath, query: { id: id } });
      // this.$router.push({ path: "/product/index", query: { id: id } });
    },
    goPath1(){
      this.$router.push({ path: "/fwzc/xsydls"});
      document.documentElement.scrollTop = 0;
    },
    getInfo(info) {
      let length = info.attrRelations.length;
      let arr = info.attrRelations;
      let id = this.typeTableList[this.typeTableList.length - 3].id;
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        if (element.productAttrId == id) {
          // console.log(element.attrValue);
          return (this.languageCode=="zh"?"竞品型号:":"Competitor model:" )+ element.attrValue;
        }
      }
    },
    changeCon() {
      let params;
      if (this.checkList.length) {
        params = {
          name: this.checkList[0].split("#")[1],
          value: this.checkList[0].split("#")[0],
        };
      }

      this.sortParams = params;
      this.getList(1);
      this.visible = false;
    },
    handleCheckedChange(arr) {
      let arr1 = arr;
      if (arr.length > 1) {
        this.checkList = [arr1[1]];
      }
    },
    reset() {
      for (let i = 0; i < this.typeList.length; i++) {
        const element = this.typeList[i];
        element.isChecked = true;
      }
      this.name = "";
      for (let i = 0; i < this.typeTableList.length; i++) {
        const element = this.typeTableList[i];
        element.interval = [];
      }
      this.sortParams = null;
      this.checkList = [];
      this.getList(1);
    },
    sortChange(column) {
      const fieldName = column.prop;
      const sortingType = column.order;
      if (sortingType == null) {
        return;
      }
      let params = {
        name: fieldName,
        value: sortingType == "descending" ? "desc" : "asc",
      };
      this.sortParams = params;
      this.getList(1);
    },
    getTypeName(list, id, type) {
      if (list != null) {
        for (let i = 0; i < list.length; i++) {
          const element = list[i];
          if (element.productAttrId == id) {
            if (element.attrValue == null || element.attrValue == "") {
              return element.attrValue;
            } else {
              if (type == 2) {
                if (!isNaN(Number(element.attrValue))) {
                  return Number(element.attrValue).toLocaleString();
                } else {
                  return element.attrValue;
                }
              } else {
                return element.attrValue;
              }
            }
          }
        }
      }
    },
    changeto(arr) {
      this.range = arr;
      let a = "";
      a = arr[0] == null ? "" : arr[0];
      // this.getList(1);
    },
    backPage(page) {
      if (page == "-1") {
        this.$router.go(-1);
      } else {
        const fullPath = this.getLocalizedPath(page);
        this.$router.replace({path:fullPath});
      }
    },
    getId(id) {
      this.$nextTick(() => {
        this.getList(1);
        this.getProductType({ productTypeId: this.id });
        const lang = this.$i18nState.locale;
        let params = {
          productTypeId: this.id,
          latestPublish: 1,
          languageCode:lang == 'zh'?'zh-CN':"en-US"
        };
        let pageParams = {
          pageNum: 1,
          pageSize: 10,
        };
        getProductList(params, pageParams).then((res) => {
          this.newProductList = res.rows;
          console.log(this.newProductList);
        });
      });
    },
    check(item) {
      const fullPath = this.getLocalizedPath("/product/productDetail");
      this.$router.replace({ path: fullPath, query: { id: item.id } });
      // this.$router.push({ path: "/product/productDetail/:lang?", query: { id: item.id } });
      document.documentElement.scrollTop = 0;
    },
    getList(val) {
      let attrFilter = [];
      for (let i = 0; i < this.typeTableList.length; i++) {
        const element = this.typeTableList[i];
        if (element.interval.length > 0) {
          if (element.interval[0] == null && element.interval[1] == null) {
            attrFilter = [];
          } else {
            console.log(element.interval[0], element.interval[0]);
            let from = element.interval[0] == null ? "" : element.interval[0];
            let to = element.interval[1] == null ? "" : element.interval[1];
            console.log(from, to);
            attrFilter.push({
              name: element.id,
              value: from + "##" + to,
            });
          }
        }
      }
      const lang = this.$i18nState.locale;   // ✅ 正确的语言获取方式
      let params = {
        productTypeId: this.id,
        attrFilter: attrFilter,
        attrOrder: [this.sortParams],
        name: this.name,
        displayStatus: 1,
        languageCode:lang == 'zh'?'zh-CN':"en-US"

      };
      if (this.sortParams == null) {
        delete params.attrOrder;
      }
      let pageParams = {
        pageNum: val,
        pageSize: 10,
      };
      getProductList(params, pageParams).then((res) => {
        this.productList = res.rows;
        this.total = res.total;
        // document.documentElement.scrollTop = 0;
      });
    },
    searchProduct() {
      // if (this.name!=null&&this.name!='') {
      this.getList(1);

      // }
    },
    getProductType(params) {
      getProductTypeList(params).then((res) => {
        this.typeList = res.data;
        for (let i = 0; i < this.typeList.length; i++) {
          const element = this.typeList[i];
          this.$set(element, "isChecked", true);
        }
        this.typeTableList = this.typeList;
        this.toInterval(this.typeTableList);
      });
    },
    sortHandle(item, i, type) {
      // console.log(item.id, i, type);
    },
    toInterval(list) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        this.$set(element, "interval", []);
      }
    },
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      // 设置表头样式，超出部分显示省略号
      return {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "150px", // 根据实际情况调整宽度
      };
    },
    renderHeader(h, { column }) {
      // 使用 el-tooltip 实现鼠标滑过显示全称
      return h(
        "el-tooltip",
        {
          props: {
            content: column.label,
            placement: "top",
          },
        },
        [
          h(
            "span",
            {
              style: {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                display: "inline-block",
                width: "100%",
              },
            },
            column.label
          ),
        ]
      );
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    const lang = this.$i18nState.locale;   // ✅ 正确的语言获取方式
    this.languageCode = lang
    let params1 = {
      languageCode:lang == 'zh'?'zh-CN':"en-US"
    }
    getProductTree(params1).then((res) => {
      let data = res.data;
      const branch = findNodePath(data, Number(this.id));
      this.treeData = branch
    });
    this.name = "";
    this.getList(1);
    this.getProductType({ productTypeId: this.id,languageCode:lang == 'zh'?'zh-CN':"en-US" });
    let params = {
      productTypeId: this.id,
      displayStatus: 1,
      latestPublish: 1,
      languageCode:lang == 'zh'?'zh-CN':"en-US"
    };
    let pageParams = {
      pageNum: 1,
      pageSize: 10,
    };
    console.log(params);
    getProductList(params, pageParams).then((res) => {
      this.newProductList = res.rows;
    });
  },
  watch: {
    $route: {
      handler(n, o) {
        this.id = n.query.id;
        this.getList(1);
        this.getProductType({ productTypeId: this.id });
        const lang = this.$i18nState.locale;
        let pageParams = {
          pageNum: 1,
          pageSize: 10,
          displayStatus: 1,
        };
        let params = {
          productTypeId: this.id,
          languageCode:lang == 'zh'?'zh-CN':"en-US"
        };
        getProductList(params, pageParams).then((res) => {
          this.newProductList = res.rows;
        });
        // this.$refs.tree.setCheckedKeys([this.id]);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.top {
  background: url("../../assets/img13.png") #1f3b6d;
  height: 70px;
  line-height: 70px;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
  cursor: pointer;
  color: #fff;
}

.active {
  background-color: #476da7;
  color: #d1d1d1;
}

h3 {
  font-weight: normal;
}

.none {
  text-align: center;
  line-height: 400px;
}
.title {
  font-size: 24px;
  line-height: 80px;
  text-align: center;
  color: #272727;
  font-weight: bold;
}
.newItem {
  background-color: #fff;
  height: 180px;
  padding: 20px;
  border-radius: 4px;
  .name {
    font-size: 20px;
    text-align: center;
    color: #272727;
  }
  .description {
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2; // 2行
    -webkit-box-orient: vertical;
    font-size: 16px;
    line-height: 2.5rem;
    margin-top: 6px;
    padding-bottom: 10px;
    border-bottom: 1px solid #8e8e8e;
  }
  .checkDetail {
    cursor: pointer;
    line-height: 34px;
    font-size: 16px;
    color: #8e8e8e;
    span {
      display: block;
      float: right;
    }
  }
}
.table_wrap {
  .table_top {
  }
}
.el-button--text,
.el-checkbox {
  color: #272727;
}
.table_main {
  background-color: #fff;
  // height:200px;
  > div {
    float: left;
    display: inline-block;
    height: 100%;
  }
}
.checkbox {
  padding: 20px;
  box-sizing: border-box;
  > label {
    display: block;
    margin-bottom: 10px;
  }
}
::v-deep .el-table .el-table__cell {
  padding: 4px 0;
}
.Breadcrumb{
  i{
    font-style: normal;
  }
  span{
    color:#2e2e2e;
    margin-right:4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/center/index.vue